module.exports = new __parcel__URL__("shop_machines_bp_water_cooler_cosmetic.d32397ef.png").toString();